// extracted by mini-css-extract-plugin
module.exports = {"Orders":"Orders_Orders__2tFt8","Orders__list":"Orders_Orders__list__o9i9G","HistoryCard":"Orders_HistoryCard__2MFh_","HistoryCard__details":"Orders_HistoryCard__details__1Sg7b"};